import type {UseFormReturn} from "react-hook-form";
import z from "zod";
import {LogoPicker} from "../../../billing/components/LogoPicker";

export const step5Schema = z.object({
  logo: z.string().optional(),
  logoContentType: z.string().optional(),
  logoHorizontalThumbnail: z.string().optional(),
  logoSquareThumbnail: z.string().optional(),
});
export type Step5Form = z.infer<typeof step5Schema>;

type Props = {
  hookForm: UseFormReturn<Step5Form>;
  disabled: boolean;
};

export function Step5Logo({hookForm, disabled}: Props) {
  const {watch, setValue} = hookForm;

  const logoSquareThumbnail = watch("logoSquareThumbnail");
  const logoContentType = watch("logoContentType");

  return (
    <>
      <p style={{marginBottom: "8px"}}>
        <strong>Avez-vous un logo ?</strong>
      </p>
      <p>Générer des factures personnalisées avec le logo de votre entreprise !</p>
      <LogoPicker
        logoSquareThumbnail={logoSquareThumbnail}
        logoContentType={logoContentType}
        onLogoChange={handleLogoChange}
        onLogoClear={handleClearLogo}
        disabled={disabled}
        label="Logo de l'entreprise"
      />
    </>
  );

  function handleLogoChange(
    contentType: string,
    base64Data: string,
    horizontalThumbnailBase64: string,
    squareThumbnailBase64: string
  ) {
    setValue("logo", base64Data);
    setValue("logoContentType", contentType);
    setValue("logoHorizontalThumbnail", horizontalThumbnailBase64);
    setValue("logoSquareThumbnail", squareThumbnailBase64);
  }

  function handleClearLogo() {
    setValue("logo", "");
    setValue("logoContentType", "");
    setValue("logoHorizontalThumbnail", "");
    setValue("logoSquareThumbnail", "");
  }
}
